<template>
    <div>
        <b-container>
            <h2>Hashtag Comparison</h2>
            <b-row>
                <b-col>
                    <b-input-group size="md" @keyup.enter="addHashtag">
                        <b-input-group-text slot="prepend">#</b-input-group-text>

                        <b-form-input v-model="addedHashtag" class="hashtag-input"/>

                        <b-input-group-append class="append-group">
                            <b-btn v-if="loading" variant="primary" disabled>
                                <font-awesome-icon :icon="['fas', 'spinner']" spin />
                            </b-btn>
                            <b-btn v-else variant="primary" @click="addHashtag">
                                <font-awesome-icon :icon="['fas', 'plus']"/>
                            </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
                <b-col sm="auto">
                    <b-btn variant="outline-secondary" @click="setResetComparison" class="mr-2">
                        <font-awesome-icon :icon="['fas', 'undo']" />
                        Clear all hashtags
                    </b-btn>
                    <b-btn variant="outline-primary" :disabled="getAllHashtags.length === 0" @click="copyHashtags" class="mr-2">
                        <font-awesome-icon :icon="['far', 'copy']" />
                        Copy all
                    </b-btn>
                        <b-btn variant="outline-primary" :disabled="getAllHashtags.length === 0" @click="saveHashtags">
                        <font-awesome-icon icon="bookmark" />
                        Save all
                    </b-btn>
                </b-col>
            </b-row>
        </b-container>
        <br>
        <b-container v-if="!hasHashtags() && !loading">
            <b-alert show variant="warning">
                <font-awesome-icon :icon="['fas', 'lightbulb']"/>&nbsp;
                Look for
                <b-btn variant="default" size="sm">
                    <i class="fas fa-balance-scale"></i> Compare
                </b-btn>button or
                <b-btn variant="default" size="sm" class="bookmarks btn-default">
                    <font-awesome-icon :icon="['fas', 'bookmark']"/>
                </b-btn> button on other screens to add hashtags here
            </b-alert>
        </b-container>
        <br>
        <b-container v-for="type in types" :key="type.index">
            <div v-if="hasHashtags(type)">
                <h5 v-if="type === 0">
                    Do not use these hashtags, very few people are following them
                </h5>
                <h5 v-if="type === 1">
                    Do not use these hashtags, your posts will disappear in the crowd
                </h5>
                <h5 v-if="type === 2">
                    Use these hashtags to get seen <strong>over time</strong>
                </h5>
                <h5 v-if="type === 3">
                    Use these hashtags to get seen
                    <span class="great-highlight">now</span>
                </h5>
                <h5 v-if="type === 4">
                    Good <strong>only</strong> for Instagram
                </h5>
                <h5 v-if="type === 5">
                    Banned on Instagram
                </h5>
                <div class="table-responsive">
                <table class="table table-sm vertical-align-middle">
                    <tbody>
                        <tr v-for="hashtag in getHashtags(type)" :key="hashtag.hashtag" class="setTags align-top">
                            <td scope="row" width="20%">
                                <b-btn variant="outline-secondary" size="sm" class="bookmarks" @click="setBookmarkHashtag(hashtag)">
                                    <font-awesome-icon :icon="['fas', 'bookmark']"/>
                                </b-btn>
                                <TagStyle :hashtag="hashtag.hashtag" :color="hashtag.color" />
                            </td>
<!--                            <td scope="row" width="20%" class="text-right">-->
<!--                                <span v-if="hashtag.mediaCount != null" v-b-tooltip.hover title="Number of instagram posts" v-b-tooltip.container="body">-->
<!--                                    {{ hashtag.mediaCount | abbreviate }}-->
<!--                                    <font-awesome-icon :icon="['fab', 'instagram']" class="text-muted"/>-->
<!--                                </span>-->
<!--                            </td>-->
                            <td scope="row" width="20%" class="text-right">
                                <span v-b-tooltip.hover title="Number of tweets with this hashtag per hour" v-b-tooltip.container="body">
                                    {{ hashtag.tweets }}
                                    <font-awesome-icon :icon="['fab', 'twitter']" class="text-muted"/> / h
                                </span>
                            </td>
                            <td scope="row" width="20%" class="text-right">
                                <div v-b-tooltip.hover title="Number of retweets with this hashtag per hour" v-b-tooltip.container="body" >
                                    {{ hashtag.retweets }}
                                    <font-awesome-icon icon="retweet"" class="text-muted"/> / h
                                </div>
                            </td>
                            <td scope="row" width="20%" class="text-right">
                                <span v-b-tooltip.hover title="Hashtag Exposure per hour: How many people get tweets with this hashtag in their home feeds" v-b-tooltip.container="body">
                                    {{ hashtag.exposure | abbreviate }}
                                    <font-awesome-icon icon="eye" class="text-muted"/> / h
                                </span>
                            </td>
                            <td scope="row" width="20%" class="text-right">
                                <b-btn class="primary-btn btn-sm" variant="primary" target="_blank" :href="mainUrl + reportUrl + hashtag.hashtag">
                                    <font-awesome-icon :icon="['fas', 'chart-bar']"/> Get Report
                                </b-btn>
                                &nbsp;
                                <b-btn variant="outline-secondary" size="sm" class="hashtag-btn" @click="setRemoveHashtag(hashtag)">
                                    <font-awesome-icon :icon="['fas', 'times']" />
                                </b-btn>
                            </td>
                        </tr>
                    </tbody>
                </table>
                </div>
            </div>
        </b-container>
        <b-modal title="Save hashtag set" id="modal1" centered ref="modal1" hide-footer>
            <SaveHashtagSet :hashtagSet="hashtags"/>
        </b-modal>
</div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import TagStyle from './helpers/TagStyle'
import SaveHashtagSet from './helpers/SaveHashtagSet'

export default {
    name: "HashtagComparison",
    components: {
        SaveHashtagSet,
        TagStyle
    },
    data() {
        return {
            mainUrl: process.env.RITETAG_URL,
            reportUrl:'/hashtag-stats/',
            addedHashtag: '',
            types: {
                'green': 3,
                'blue': 2,
                'red': 1,
                'grey': 0,
                'instagram': 4,
                'instagram-banned': 5
            }
        }
    },
    methods: {
        ...mapActions('comparison', [
            'setBookmarkHashtag',
            'setAddToComparison',
            'setResetComparison',
            'setRemoveHashtag',
        ]),
        ...mapActions('stats', {
            getStatsInfo: 'get',
        }),
        addHashtag() {
            const input = this.addedHashtag
            // sanitize
            this.addedHashtag = ''
            input.trim().split(/[#, ] ?/gmi).forEach(tagName => {
                const hashtag = tagName.trim()
                if (!hashtag) {
                    return
                }
                this.getStatsInfo(hashtag).then(() => {
                    this.setAddToComparison(this.newHashtag[hashtag])
                })
            })
        },
        copyHashtags () {
            const tags = this.getHashtags().map(x => `#${x}`)
            this.$clipboard(tags.join(' '))
            this.$notify({ type: 'success', text: 'Hashtags copied to clipboard' })
        },
        saveHashtags () {
            this.$refs['modal1'].show()
        },
        hasHashtags (type) {
            const hashtags = this.getHashtags(type)
            return hashtags.length > 0
        },
        getHashtags (type) {
            switch (type) {
                case 0:
                    return this.getUnusedHashtags
                case 1:
                    return this.getOverusedHashtags
                case 2:
                    return this.getGoodHashtags
                case 3:
                    return this.getGreatHashtags
                case 4:
                    return this.getInstagramHashtags
                case 5:
                    return this.getInstagramBannedHashtags
                default:
                    return this.getAllHashtags
            }
        }
    },
    computed: {
        ...mapGetters('comparison', [
            'getOverusedHashtags',
            'getGoodHashtags',
            'getGreatHashtags',
            'getUnusedHashtags',
            'getInstagramHashtags',
            'getInstagramBannedHashtags',
            'getAllHashtags',
            'getBookmarkedHashtags'
        ]),
        ...mapGetters('stats', {
            newHashtag: 'getHashtag'
        }),
        ...mapState('stats', ['loading', 'error']),
        hashtags () {
            return this.getHashtags().map(x => {
                return {text: x}
            })
        }
    },
    watch: {
        error(error) {
            if (error) {
                this.$notify({ type: 'error', text: 'Oops! There was an error. Check your internet connection and refresh the page' })
            }
        }
    }
}
</script>

<style scoped>
.hashtag-input {
    height: auto;
}
.bookmarks {
    margin-right: 3px;
}
.great-highlight {
    color: #d20091;
}

.prepend-btn {
  background-color: #CCCCCC;
  border: none;
}
.append-group {
    z-index: 0;
}
.table {
    white-space: nowrap;
}
@media screen and (max-width: 628px) {
    #tag-enter {
        width: 90%;
    }
}
</style>
